var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer shadow-lg"},[_c('b-button',{staticClass:"w-100",attrs:{"variant":"primary-theme","disabled":_vm.isDisable},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }